export default 'https://wa.me/989012175046'